<template lang="pug">
  v-row.align-center.text-center
    v-col.flex-shrink-1.flex-grow-0
      v-btn(fab icon :disabled="!isBackButtonEnabled" :large="showLargeButton")
        v-icon(color="teal" @click="onPrevButtonClick") fas fa-chevron-circle-left
    v-col.flex-shrink-0.flex-grow-1.pa-0
      v-row.pt-3(no-gutters)
        v-col {{ weekLabel }}
        v-col {{ weekRange }}
    v-col.flex-shrink-1.flex-grow-0
      v-btn(fab icon :large="showLargeButton")
        v-icon(color="teal" @click="onNextButtonClick")  fas fa-chevron-circle-right

</template>

<script lang="ts">
import Vue from 'vue'
import moment from 'moment'
import {Component, Prop} from "vue-property-decorator"

@Component({
})
export default class CalendarWeekSelector extends Vue {
  @Prop({ type: String, required: true }) isoWeek!: string
  @Prop({ type: Boolean, default: true }) readonly allowNavigationToPast!: boolean

  get weekLabel (): string {
    return `${moment(this.isoWeek).format('W')}. ${this.$t('orderPage.weekname')}`
  }

  get weekRange (): string {
    const start = moment(this.isoWeek)
    const end = start.clone().add(1, 'week')

    return `${start.format('D.M')} - ${end.format('D.M')}`
  }

  get isBackButtonEnabled (): boolean {
    if (this.allowNavigationToPast) {
      return true
    } else {
      const currentWeekStart = moment().startOf('isoWeek')
      const previousWeekStart = moment(this.isoWeek).subtract(1, 'week').startOf('isoWeek')

      return !previousWeekStart.isBefore(currentWeekStart)
    }
  }

  get showLargeButton (): boolean {
    return !this.$vuetify.breakpoint.xs
  }

  onNextButtonClick (): void {
    this.$emit('update:isoWeek', moment(this.isoWeek).add(1, 'week').format('GGGG[W]WW'))
  }

  onPrevButtonClick (): void {
    this.$emit('update:isoWeek', moment(this.isoWeek).subtract(1, 'week').format('GGGG[W]WW'))
  }

}
</script>

<style lang="stylus" scoped>

</style>
